var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  bannerTypes: () => bannerTypes,
  cardsId: () => cardsId,
  screensId: () => screensId,
  yayoyakiHeaderTypes: () => yayoyakiHeaderTypes
});
const screensId = {
  PERSONAL_START: "personal_start"
};
const cardsId = {
  REAL_ESTATE_CARD: "real_estate_card",
  FREELANCE_PAYERS_CLASIFICATOR_CARD: "freelance_payers_clasificator_card"
};
const bannerTypes = {
  ERROR: "banner_error"
};
const yayoyakiHeaderTypes = ["wizard"];
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  bannerTypes,
  cardsId,
  screensId,
  yayoyakiHeaderTypes
});
